// import { OidcRoutes } from "Feature/Auth/Route/OidcRoutes";
import MasooliatMadaniRoutes from 'Feature/Asansour/Common/Constant/MasooliatMadaniRoutes';
import { AtashsooziOmumiRoutes } from 'Feature/Atashsoozi/Constant/AtashsooziOmumiRoutes';
import BasicInfoRoutes from 'Feature/BasicInfo/Common/Constant/BasicInfoRoutes';
import LandingRoutes from 'Feature/Common/Common/Constant/LandingRoutes';
import HavadesEnferadiRoutes from 'Feature/Hadeseh/Common/Constant/HavadesEnferadiRoutes';
import ShakhsSalesRoutes from 'Feature/Khodro/ShakhsSales/Routes/ShakhSalesRoutes';
import { LifeInsuRoutes } from 'Feature/LifeInsu/Constant/LifeInsuRoutes';
import MosaferatiRoutes from 'Feature/Mosaferati/Common/Constant/MosaferatiRoute';
import IRoute from 'Shared/Routes/Models/IRoute';

const AppRoutes: IRoute[][][] = [
  LandingRoutes,
  // OidcRoutes,
  ShakhsSalesRoutes,
  AtashsooziOmumiRoutes,
  BasicInfoRoutes,
  LifeInsuRoutes,
  MosaferatiRoutes,
  HavadesEnferadiRoutes,
  MasooliatMadaniRoutes,
];

export default AppRoutes;
